define('modules/page_listing/models/tag',['require','exports','module','backbone'],function(require, exports, module) {
  "use strict";

  var Backbone = require("backbone");

  module.exports = Backbone.Model.extend({
    defaults: {
      text: ""
    }
  });
});

